import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=46fcdf56&scoped=true&"
import script from "./DesktopHeader.vue?vue&type=script&lang=ts&"
export * from "./DesktopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopHeader.vue?vue&type=style&index=0&id=46fcdf56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcdf56",
  null
  
)

export default component.exports